import { NAV_DATA } from "./navData";

/*
  Add the searchable text of every routed page here. A React SPA cannot read an
  unmounted route's rendered DOM, so site-wide search needs an index like this.

  Keep `path` exactly the same as the path used in <Route path="...">.

  Example:
  {
    title: "About ASSOCHAM",
    path: "/about-us",
    keywords: ["about", "chamber", "history", "vision", "mission"],
    content: `Paste the page's visible text here, or import the same content
              object that the page component renders.`
  }

  Pages present in NAV_DATA are included automatically by the code below. Add
  them here too when you want their complete body text to be searchable; records
  with the same path are merged.
*/
export const PAGE_SEARCH_DATA = [
  // Add one object per route.
];

const asText = (value) => {
  if (Array.isArray(value)) return value.join(" ");
  return value == null ? "" : String(value);
};

const isSearchablePath = (path) =>
  typeof path === "string" && path.trim() !== "" && path !== "#";

const navRecords = [];

const walkNav = (items = [], parents = []) => {
  items.forEach((item) => {
    if (!item || typeof item === "string") return;

    const title = item.label || item.title || "";
    const path = item.href || item.path || "";
    const parentKeywords = parents.filter(Boolean);

    if (title && isSearchablePath(path)) {
      navRecords.push({
        title,
        path,
        keywords: [
          ...parentKeywords,
          ...(
            Array.isArray(item.keywords)
              ? item.keywords
              : [item.keywords]
          ).filter(Boolean),
        ],
        content: item.searchContent || item.content || "",
      });
    }

    const nextParents = title ? [...parents, title] : parents;
    if (Array.isArray(item.items)) walkNav(item.items, nextParents);
    if (Array.isArray(item.councils)) walkNav(item.councils, nextParents);
  });
};

walkNav(NAV_DATA);

// Merge duplicate paths so the nav title/keywords and complete page body can
// contribute to one search result.
const mergedByPath = new Map();

[...navRecords, ...PAGE_SEARCH_DATA].forEach((record) => {
  const path = record?.path || record?.href;
  if (!record?.title || !isSearchablePath(path)) return;

  const existing = mergedByPath.get(path);
  if (!existing) {
    mergedByPath.set(path, {
      title: record.title,
      path,
      keywords: asText(record.keywords),
      content: asText(record.content),
    });
    return;
  }

  mergedByPath.set(path, {
    title: record.title || existing.title,
    path,
    keywords: `${existing.keywords} ${asText(record.keywords)}`.trim(),
    content: `${existing.content} ${asText(record.content)}`.trim(),
  });
});

export const SEARCH_DATA = Array.from(mergedByPath.values());
